// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderDetailsLabelPrintButton_container__1MGLK","text":"OrderDetailsLabelPrintButton_text__3MAdB","text-ltr":"OrderDetailsLabelPrintButton_text-ltr__vWwJn"};